import React from 'react';
import ReactDOM from 'react-dom/client'; // Correct import for React 18
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')); // Create root
root.render(<App />); // Render app using the createRoot method
